import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { LoadingIndicatorService } from '../../core/services/loading-indicator-service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loading-indicator',
  imports: [AsyncPipe],
  templateUrl: './loading-indicator.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loading-indicator.css',
})
export class LoadingIndicator {
  constructor(loadingService: LoadingIndicatorService) {
    this.loading$ = loadingService.loading$;
  }

  protected readonly loading$: Observable<boolean>;
}
